export const FALLBACK_LANG = 'en-GB';

export const LOCALES_MATCHES = {
  'es-ES': 'es',
  'en-GB': 'en-gb',
  'fr-FR': 'fr',
  'nl-NL': 'nl',
  'pl-PL': 'pl',
  es: 'es',
  fr: 'fr',
  en: 'en-gb',
  nl: 'nl',
  pl: 'pl',
  default: FALLBACK_LANG
};

export const NUMERAL_LOCALES_MATCHES = {
  'es-ES': 'es',
  'en-GB': 'en-gb',
  'fr-FR': 'fr',
  'nl-NL': 'nl-nl',
  'pl-PL': 'pl',
  es: 'es',
  fr: 'fr',
  en: 'en-gb',
  nl: 'nl-nl',
  pl: 'pl',
  default: FALLBACK_LANG
};

export const FAQS_URLS = {
  es:
    'https://ontruck.com/es/preguntas-frecuentes/todo-lo-que-tienes-que-saber-sobre-ontruck/',
  fr: 'https://ontruck.com/fr/faq/information-ontruck/',
  'en-gb': 'https://ontruck.com/uk/faq/information-ontruck/',
  nl: 'https://ontruck.com/nl/veelgestelde-vragen/transporteurs-info/'
};
